import Checkbox from '@atlaskit/checkbox';
import Tooltip from '@atlaskit/tooltip';

interface CheckboxCellProps {
  isChecked: boolean;
  isDisabled: boolean;
  tooltip: string;
}

export function CheckboxCell({
  isChecked,
  isDisabled,
  tooltip,
}: CheckboxCellProps) {
  return (
    <Tooltip content={tooltip} position="top-start">
      <Checkbox isChecked={isChecked} isDisabled={isDisabled} />
    </Tooltip>
  );
}
